import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { SeasonEnum } from '../../../../../../../../../lib/graphql'

interface SeasonHalfMonthButtonProps {
  season: SeasonEnum
  onClick?: () => void
  position: 'start' | 'end'
}
const SeasonHalfMonthButton = ({
  season,
  onClick,
  position,
}: SeasonHalfMonthButtonProps) => {
  const seasonColors = {
    [SeasonEnum.LOW]: '#0cbc8b',
    [SeasonEnum.MEDIUM]: '#f1960d',
    [SeasonEnum.HIGH]: '#ff0000',
  }

  return (
    <div
      className={clsx(s.triangle, s[position], { [s.clickable]: !!onClick })}
      style={{ backgroundColor: seasonColors[season] }}
      onClick={onClick}
    />
  )
}

interface SeasonMonthButtonProps {
  startSeason: SeasonEnum
  endSeason: SeasonEnum
  onStartClick?: () => void
  onEndClick?: () => void
  className?: string
}
export const SeasonMonthButton = ({
  startSeason,
  endSeason,
  onStartClick,
  onEndClick,
  className,
}: SeasonMonthButtonProps) => (
  <div className={clsx(s.container, className)}>
    <SeasonHalfMonthButton
      season={startSeason}
      onClick={onStartClick}
      position='start'
    />
    <SeasonHalfMonthButton
      season={endSeason}
      onClick={onEndClick}
      position='end'
    />
  </div>
)

export default SeasonMonthButton
